import React, { Component } from "react";
import Header from "./header";
import SearchResults from "./search-results";
import { Isvg, SearchField, Truncate } from "../../components";
import { BookStore, Dispatcher } from "../../flux";
import TOCLevel from "./toc-level";
import numeral from "numeral";
import AccessibleSearchResults from "../../../accessability/accessibleSearchResults";

class TOCContainer extends Component {
  constructor(props) {
    super(props);
    const book = BookStore.get(props.isbn);
    this.state = {
      toc: [],
      lastCFI: book.lastCFI,
      showSearchResults: false,
      value: "",
      bookSearchResults: []
    };

    this._tocUpdated = this._tocUpdated.bind(this);
    this._pageScroll = this._pageScroll.bind(this);
    this._drillDown = this._drillDown.bind(this);
    this._drillUp = this._drillUp.bind(this);
    this._pageReady = this._pageReady.bind(this);
    this._goToFirst = this._goToFirst.bind(this);
    this._goToPage = this._goToPage.bind(this);
    this._checkTOCNodeLengths = this._checkTOCNodeLengths.bind(this);
    this._searchBook = this._searchBook.bind(this);
    this._changeSearchTerm = this._changeSearchTerm.bind(this);
    this._reset = this._reset.bind(this);
  }

  componentDidMount() {
    // Once mounted, get rid of any stored TOC data in the cache
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 4);
    Dispatcher.bind(Dispatcher.BOOK_TOC_LOADED, this._tocUpdated);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.bind(Dispatcher.BOOK_PAGE_LOAD, this._pageReady);
    this.toc = [];
    this.currentLevel = [];
    this._pageReady();
    this._rendered();
    this._tocUpdated();
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_TOC_LOADED, this._tocUpdated);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_SCROLL, this._pageScroll);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_LOAD, this._pageReady);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 4);
  }

  componentDidUpdate() {
    this._rendered();
  }

  _tocUpdated(isbn) {
    const book = BookStore.get(this.props.isbn);
    const toc = book.getTOC();
    if (toc && (!this.toc || this.toc.length === 0)) {
      this._processTOC(toc);
      this.forceUpdate(() => {
        // TODO:: remove this and use toc as a state
        this._updateActiveLevels(this.currentLevel, book.pageCFI); // TODO :: need to provide the scrolled cfi instead of pageCFI here, which means it needs to be tracked as part of the book object
      });
    }
  }

  _pageScroll(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);
    if (book.layout !== "fixed") {
      this.setState({ lastCFI: data.cfi });
      var onLevelOne =
        this.currentLevel.children.length > 0 &&
        this.currentLevel.children[0].level === 1 &&
        this.currentLevel.children.map(a => a.level) &&
        // TODO: This looks like a bug...
        // eslint-disable-next-line no-undef
        !!allLevels.reduce((a, b) => {
          return a === b ? a : NaN;
        });
      if (this.currentLevel && !onLevelOne) {
        this._updateActiveLevels(this.currentLevel, data.cfi);
      }
    }
  }

  _rendered() {
    if (this.currentLevel && this.currentBookData) {
      this._updateActiveLevels(this.currentLevel, this.currentBookData.cfi);
    }
    if (!this.toc || this.toc.length === 0) {
      Fraction.Helpers.addLoader("#toc-container");
    } else {
      Fraction.Helpers.removeLoader("#toc-container");
    }
    this._checkTOCNodeLengths();
    // update highlight of toc here
  }

  _drillDown(tocElement) {
    this._reset();
    // Go down a level of the TOC, animate the new TOC over the old.
    $("#ghost-toc-container").html("");
    $("#ghost-toc-container").css("z-index", "");
    tocElement.scrollPosition = $("#toc-container")
      .find(".level-container")
      .scrollTop();
    $("#toc-container")
      .children()
      .each(function() {
        var clone = $(this).clone();
        // our dom for display should not react poorly with react
        clone.removeAttr("data-reactid");
        $("#ghost-toc-container").append(clone);
      });
    $("#toc-container").css("margin-left", "100%");
    $("#ghost-toc-container").css("margin-left", "0");
    $("#ghost-toc-container").show();
    this.setState({ currentLevel: tocElement });
    $("#ghost-toc-container")
      .find(".level-container")
      .scrollTop(tocElement.scrollPosition);
    Fraction.Helpers.runAfterRender(() => {
      $("#toc-container")
        .find(".level-container")
        .scrollTop(0);
      $("#toc-container").animate(
        {
          marginLeft: 0
        },
        175,
        "linear",
        () => {
          $("#ghost-toc-container").html("");
          $("#ghost-toc-container").hide();
          this.setState({ currentLevel: tocElement });

          if (this.currentLevel) {
            this._updateActiveLevels(this.currentLevel, this.state.lastCFI);
          }
        }
      );
      $("#toc-container .hiddenTitle").focus();
    });
    Fraction.Reporter.gaEvent("reader/panel/toc/drill-down");
  }

  _drillUp() {
    // Go up a level of the TOC, animate the old TOC over the new.
    $("#ghost-toc-container").html("");
    $("#ghost-toc-container").css("z-index", "2");
    $("#toc-container")
      .children()
      .each(function() {
        $(this)
          .clone()
          .appendTo("#ghost-toc-container");
      });
    $("#toc-container").css("margin-left", "0");
    $("#ghost-toc-container").css("margin-left", "0");
    $("#ghost-toc-container").show();
    this.setState({ currentLevel: this.parentLevel });
    Fraction.Helpers.runAfterRender(() => {
      $("#toc-container")
        .find(".level-container")
        .scrollTop(this.currentLevel.scrollPosition);
      $("#ghost-toc-container").animate(
        {
          marginLeft: $("#ghost-toc-container")
            .parent()
            .width()
        },
        175,
        "linear",
        () => {
          $("#ghost-toc-container").html("");
          $("#ghost-toc-container").hide();
          if (this.currentLevel) {
            this._updateActiveLevels(this.currentLevel, this.state.lastCFI);
          }
        }
      );
      $("#toc-container .hiddenTitle").focus();
    });
    Fraction.Reporter.gaEvent("reader/panel/toc/drill-up");
  }

  _pageReady(isbn, e, data) {
    if (data && data.cfi) {
      this.setState({ lastCFI: data.cfi }, () => {
        const book = BookStore.get(this.props.isbn);
        this._updateActiveLevels(
          this.currentLevel ? this.currentLevel : this.toc,
          this.state.lastCFI || book.pageCFI
        );
      });
    }
  }

  _updateActiveLevels(level, cfi) {
    if (cfi) {
      const book = BookStore.get(this.props.isbn);
      $("#toc-container .up-level.active").removeClass("active");
      var changedNode =
        this.lastActiveKey !== $(".toc-level.active").data("activekey");
      this.lastActiveKey = $("#toc-container .toc-level.active").data(
        "activekey"
      );
      $("#toc-container .toc-level.active")
        .removeClass("active")
        .removeAttr("aria-current");

      this._getLocationFast(level.children, level, book.pageCFI + "!" + cfi);

      // scroll to node in TOC
      if (
        !this.lastActiveKey ||
        (changedNode && $(".toc-level.active").length > 0)
      ) {
        if (
          !Fraction.Helpers.isScrolledIntoView(
            $(".toc-level.active").get(0),
            true,
            $(".toc-container .level-container").get(0)
          )
        ) {
          setTimeout(function() {
            let activeLevel = $("#toc-container .toc-level.active").get(0);
            if (activeLevel) {
              var scrollTo = activeLevel.offsetTop - 10;
              if (
                activeLevel.offsetTop >
                $("#toc-container .level-container").scrollTop()
              ) {
                scrollTo =
                  activeLevel.offsetTop -
                  $("#toc-container .level-container").innerHeight() +
                  $("#toc-container .toc-level.active").innerHeight() +
                  10;
              }
              $(".toc-container .level-container").animate(
                {
                  scrollTop: scrollTo
                },
                500,
                "swing"
              );
            }
          }, 100);
        }
      }
    }
  }

  _getLocationFast(list, level, cfi) {
    if (!cfi) {
      return;
    }
    if (
      level &&
      level.nextCFI &&
      Jigsaw.CFIUtils.compareCFIs(cfi, level.nextCFI) >= 0
    ) {
      return $(".up-level").addClass("active");
    }
    var item, comp;
    if (list.length === 1) {
      item = list[0];
      comp = Jigsaw.CFIUtils.compareCFIs(cfi, item.cfi);
    } else {
      var midpoint = Math.floor(list.length / 2.0);
      item = list[midpoint];
      comp = Jigsaw.CFIUtils.compareCFIs(cfi, item.cfi);
      if (comp === 1) {
        // in the top half
        return this._getLocationFast(list.slice(midpoint), false, cfi);
      } else if (comp === 0) {
        // found it!
      } else {
        return this._getLocationFast(list.slice(0, midpoint), false, cfi);
      }
    }
    if (item && comp !== -1) {
      var obj = $('.toc-level[data-activekey="' + item.dom.key + '"]');
      if (obj.length > 0) {
        obj.addClass("active").attr("aria-current", "location");
      }
    } else {
      $(".up-level").addClass("active");
    }
  }

  _getLocation(list, cfi) {
    if (!cfi) {
      return;
    }
    var item;
    var i;
    if (list.length === 1) {
      item = list[0];
    } else {
      for (i = 0; i < list.length; i++) {
        var comp = Jigsaw.CFIUtils.compareCFIs(cfi, list[i].cfi);
        if (comp === 1) {
        } else if (comp === 0) {
          item = list[i];
          break;
        } else {
          if (i > 0) {
            item = list[i - 1];
          } else {
            item = false;
          }
          break;
        }
      }
    }
    if (!item && i > 0) {
      item = list[list.length - 1];
      if (
        item.parentLevel &&
        Jigsaw.CFIUtils.compareCFIs(cfi, item.parentLevel.nextCFI) === 1
      ) {
        item = false;
      }
    } else if (
      !item &&
      (!list[0].parentLevel ||
        Jigsaw.CFIUtils.compareCFIs(cfi, list[0].parentLevel.cfi) >= 0)
    ) {
      item = list[0];
    }
    if (item) {
      var obj = $('.toc-level[data-activekey="' + item.dom.key + '"]');
      if (obj.length > 0) {
        obj.addClass("active");
      }
    } else {
      $(".up-level").addClass("active");
    }
    if (item && item.children && item.children.length > 0) {
      //this._getLocation(item.children, cfi);
    }
  }

  _processTOC(tocToProcess) {
    // Parse the TOC to get it into a tiered format that is easier
    // to use than the flat structure given to us by Jigsaw
    const book = BookStore.get(this.props.isbn);
    this.toc = [];
    var currentLevel = 0;
    var currentParent = [];
    var currentNode = [];
    var uniqid = 0;
    var prevCFIs = {};
    var lastProcessedLevels = {};
    var hasPages = false;
    var i;

    for (i = 0; i < tocToProcess.length; i++) {
      hasPages = hasPages || tocToProcess[i].page;
      tocToProcess[i].title = tocToProcess[i].title.decodeHTML();
    }
    for (i = 0; i < tocToProcess.length; i++) {
      if (
        i === 0 &&
        (tocToProcess[i].title === book.title ||
          tocToProcess[i].title.toLowerCase().indexOf("cover") === 0)
      ) {
        tocToProcess[i].title = book.title;
        tocToProcess[i].titleNode = true;
      }
      tocToProcess[i].children = [];
      tocToProcess[i].previousCFI = prevCFIs[tocToProcess[i].level];
      prevCFIs[tocToProcess[i].level] = tocToProcess[i].cfi;
      if (lastProcessedLevels[tocToProcess[i].level]) {
        lastProcessedLevels[tocToProcess[i].level].nextCFI =
          tocToProcess[i].cfi;
      }
      lastProcessedLevels[tocToProcess[i].level] = tocToProcess[i];
      tocToProcess[i].dom = (
        <TOCLevel
          activekey={"toc_level_" + tocToProcess[i].cfi + "_" + uniqid}
          key={"toc_level_" + tocToProcess[i].cfi + "_" + uniqid++}
          info={tocToProcess[i]}
          goToPage={this._goToPage}
          drillDown={this._drillDown}
          hasPages={!!hasPages}
        />
      );
      uniqid++;

      if (tocToProcess[i].level === 1) {
        tocToProcess[i].parentTitle = "Contents";
        this.toc.push(tocToProcess[i]);
        currentLevel = 1;
        currentNode = tocToProcess[i];
        currentParent = [tocToProcess[i]];
      } else {
        tocToProcess[i].childLevel = true;
        if (currentLevel === tocToProcess[i].level) {
          currentNode.parentLevel.children.push(tocToProcess[i]);
          tocToProcess[i].parentTitle = currentNode.parentLevel.title;
          tocToProcess[i].parentLevel = currentNode.parentLevel;
          currentNode = tocToProcess[i];
        } else if (currentLevel < tocToProcess[i].level) {
          // node level is deeper
          currentNode.children.push(tocToProcess[i]);
          tocToProcess[i].parentTitle = currentNode.title;
          tocToProcess[i].parentLevel = currentNode;
          currentNode = tocToProcess[i];
        } else if (currentLevel > tocToProcess[i].level) {
          // node level is shallower
          var myParent = currentNode.parentLevel;
          for (var j = 0; j < currentLevel - tocToProcess[i].level; j++) {
            myParent = myParent.parentLevel;
          }
          myParent.children.push(tocToProcess[i]);
          tocToProcess[i].parentTitle = myParent.title;
          tocToProcess[i].parentLevel = myParent;
          currentNode = tocToProcess[i];
          //currentParent = [tocToProcess[i]];
        }
        currentLevel = tocToProcess[i].level;
        if (
          currentNode.parentLevel &&
          (!currentNode.parentLevel.page ||
            currentNode.parentLevel.page.length === 0)
        ) {
          currentNode.parentLevel.page = currentNode.page;
        }
      }
    }
  }

  _goToFirst() {
    const book = BookStore.get(this.props.isbn);
    Fraction.Router.setRoute("/books/" + book.isbn + "/first");
    Fraction.Reporter.gaEvent("reader/panel/toc/navigate-to-first");
  }

  _goToPage(cfi, page, path) {
    const book = BookStore.get(this.props.isbn);
    book.goTo({
      cfi: cfi,
      page: page,
      path: path,
      callback: () => {
        // TODO:: We have much better ways to focus Viewport.focus()
        //        Also probably doesn't really belong here....
        $("#jigsaw-placeholder-outer")
          .find("iframe")
          .first()
          .focus();
      }
    });
    if (Fraction.Helpers.isSmallScreen()) {
      this.props.close("skipGA");
    }
    Fraction.Reporter.gaEvent("reader/panel/toc/navigate-to-page");
  }

  _checkTOCNodeLengths() {
    var foundElemInView = false;
    $(".section .title:not(.dotted), .book-title").each(function() {
      if (Fraction.Helpers.isScrolledIntoView(this)) {
        if ($(this).text().length > 0) {
          foundElemInView = true;
          $(this).dotdotdot({ height: 40 });
          var pageNumberDom = $(this)
            .parent()
            .find(".page");
          pageNumberDom.css(
            "line-height",
            pageNumberDom.parent().outerHeight() + "px"
          );
          $(this).addClass("dotted");
        }
      } else if (foundElemInView) {
        return;
      }
    });
  }

  _searchBook() {
    let book = BookStore.get(this.props.isbn);
    let toc = book.getTOC();
    let query = this.state.value && this.state.value.toLowerCase();
    let counter = toc.length;
    let i = 0;
    let titles = [];
    let currentTitle;

    if (!query || query.length === 0) {
      this.setState({ value: null, bookSearchResults: [] });
      return false;
    }

    for (i; i < counter; i++) {
      currentTitle = toc[i].title.toLowerCase();
      if (currentTitle.indexOf(query) !== -1) {
        titles.push(toc[i]);
      }
    }

    return this.setState({
      toc: titles,
      bookSearchResults: titles,
      showSearchResults: true
    });
  }

  _changeSearchTerm(value) {
    this.setState({ value: value }, () =>
      Fraction.Helpers.throttle(
        () => {
          this._searchBook();
        },
        15,
        300,
        "search-input-field"
      )
    );
  }

  _reset() {
    this.setState({
      showSearchResults: false,
      bookSearchResults: [],
      value: null
    });
  }

  _showToc(levelToRender, levels) {
    if (!levelToRender) {
      levelToRender = { children: this.toc };
    }
    if (levelToRender && levelToRender.children.length > 0) {
      for (var i = 0; i < levelToRender.children.length; i++) {
        levels.push(levelToRender.children[i].dom);
      }
      if (levelToRender.children[0].childLevel) {
        this.parentLevel = levelToRender.parentLevel;
        this.returnText = levelToRender.children[0].parentTitle;

        let returnLevelOnClick = function(e) {
          $(e.currentTarget.className).addClass("active");
          this._goToPage(
            levelToRender.cfi,
            levelToRender.page,
            levelToRender.path
          );
        }.bind(this);

        this.returnLevel = (
          <button
            onClick={e => {
              returnLevelOnClick(e);
            }}
            className="noButton up-level-button"
          >
            <Isvg id="go-to-arrow" src={"/img/launch_icon.svg"}>
              NS
            </Isvg>
            <div className="up-level">
              <Truncate
                id="go-to"
                aria-hidden="true"
                key={"truncated-title-" + this.state.currentLevel.cfi}
                lines={2}
              >
                {i18n.t("reader.toc.go-to", { title: this.returnText })}
              </Truncate>
              <span className="hiddenTitle">
                {i18n.t("reader.toc.go-to", { title: this.returnText })}
              </span>
            </div>
          </button>
        );
      }
      this.currentLevel = levelToRender;
    }
  }

  render() {
    // Find the level we want to render and put it into an array with the
    // appropriate DOM elements
    var levels = [];
    var edition = false;
    const book = BookStore.get(this.props.isbn);
    this.returnLevel = undefined;
    this.returnText = undefined;
    this.parentLevel = undefined;
    this.currentLevel = undefined;

    if (this.toc) {
      this._showToc(this.state.currentLevel, levels);
    }

    if (book.edition > 1) {
      edition = i18n.t("library.book.edition", {
        edition: numeral(book.edition).format("0o")
      });
    }

    let bookInfo = (
      <div>
        <div
          key="ghost-level-toc"
          tabIndex="-1"
          className="toc-container"
          id="ghost-toc-container"
        />
        <div className="toc-container" id="toc-container">
          <h3 className="hiddenTitle" tabIndex="-1">
            {this.returnText ? this.returnText : i18n.t("reader.panels.toc")}
          </h3>
          {this.returnLevel}
          <AccessibleSearchResults total={levels.length}/>
          <ul
            className={
              "level-container" + (this.returnLevel ? " return-level" : "")
            }
            onScroll={this._checkTOCNodeLengths}
            style={{ marginTop: this.returnLevel ? 60 : 120 }}
          >
            {!this.returnLevel && (
              <li className="toc-title title toc-level level-1 group">
                <button className="section no-drill" onClick={this._goToFirst}>
                  {book.coverURL && (
                    <img src={book.coverURL.replace(":width", "60")} />
                  )}
                  <div className="book-title" title={book.title}>
                    <span>{book.title}</span>
                  </div>
                  {edition && <div className="edition">{edition}</div>}
                  <div className="author">{book.author}</div>
                </button>
              </li>
            )}
            {levels}
          </ul>
        </div>
      </div>
    );

    return (
      <div>
        <Header
          drillUp={this._drillUp}
          returnLevel={this.returnLevel}
          returnText={this.returnText}
          title={this.props.title}
        />
        {(this.state.showSearchResults || !this.returnLevel) && (
          <div id="toc-Searchfield" className="panel-header-container">
            <SearchField
              value={this.state.value}
              onChange={this._changeSearchTerm}
              reset={this._reset}
              placeholder={i18n.t("reader.panels.search-toc")}
              search={this._searchBook}
              incremental
            />
          </div>
        )}
        {this.state.showSearchResults && (
          <SearchResults
            chapters={this.state.bookSearchResults}
            checkTOCNodeLengths={this._checkTOCNodeLengths}
            goToPage={this._goToPage}
            reset={this._reset}
          />
        )}
        {!this.state.showSearchResults && bookInfo}
      </div>
    );
  }
}

const gadgetId = "toc";
module.exports = {
  class: TOCContainer,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      learnMore: false,
      launch: "// TODO",
      toggle: false,
      expanded: false,
      hideHeader: true,
      type: "panel",
      enabled: () => Fraction.Brand.Sidebar.Buttons.toc,
      sidebar: {
        icon: "/img/toc/toc.svg",
        action: () => {
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
